module.exports = __webpack_public_path__ + "static/sauer-catering-logo-title-1b5513c3c6d3f843bd16aec996148448.svg";